import schedule from '@/api/schedule-time'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  sub_programs: [],
  time_Ids: [],
  time_swaps: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_SUB_PROGRAMS(state, data) {
    state.sub_programs = data
  },
  SET_TIME_ID(state, data) {
    state.time_Ids = data
  },
  SET_TIME_SWAP(state, data) {
    state.time_swaps = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return schedule.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return schedule.store(data)
  },

  update(context, data) {
    return schedule.update(data)
  },
  destroy(context, id) {
    return schedule.destroy(id)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await schedule.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  async dataBeforeCreate(context) {
    if (!context.state.sub_programs.length > 0) {
      let response = await schedule.getSubProgram()
      context.commit('SET_SUB_PROGRAMS', response)
    }
    if (!context.state.time_Ids.length > 0) {
      let response = await schedule.getTimeId()
      context.commit('SET_TIME_ID', response)
    }
    if (!context.state.time_swaps.length > 0) {
      let response = await schedule.getTimeSwap()
      context.commit('SET_TIME_SWAP', response)
    }
  }
}
